<template>
  <div class="button" :class="'col-md-' + col">
    <button @click="onClick" :type="type" class="button-search" :class="'button-' + btnColor"
            :style="{'float': whichSide, 'width': width}" :disabled="disabled">
      <span v-if="haveLoading" class="button-validate">
        <span v-if="!loading" class="button-label" :class="icon ? 'button-icon' : ''">
          <i v-if="icon === 'excel'" class="fa fa-file-excel-o"/>
          {{ label }}
        </span>
        <div v-else class="loading-btn button-loading">
          <div class="spinner-btn button-spinner">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
          </div>
        </div>
      </span>
      <span v-else class="button-validate">
        <span class="button-label" :class="icon ? 'button-icon' : ''">
          <i v-if="icon === 'excel'" class="fa fa-file-excel-o"/>
          {{ label }}
        </span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "btnCustom",
  props: {
    label: {
      required: true,
    },
    col: {
      default: '12'
    },
    icon: {
      default: ''
    },
    loading: {
      default: false,
    },
    haveLoading: {
      default: false,
    },
    whichSide: {
      default: 'left',
    },
    type: {
      default: ''
    },
    disabled: {
      default: false
    },
    // Cores pré setadas para o botão, referente aos padrões do figma
    // blue yellow green red gray
    btnColor: {
      default: 'blue'
    },
    width: {
      default: ''
    }
  },
  methods: {
    onClick() {
      this.$emit('emit-click')
    }
  }
}
</script>

<style lang="scss" scoped>

.button {

  &-search {
    border: none;
    border-radius: 4px !important;
    padding: 10px 46px;
    transition: .2s;
    height: 40px;
  }

  &-blue {
    background: #2F23D6;
    color: #FFFFFF;

    &:hover, &:active {
      background: #352DA5;
    }
  }

  &-yellow {
    background: #FDD944;
    color: #3A424E;

    &:hover, &:active {
      background: #F9CA04;
    }
  }

  &-green {
    background: #2ACC6B;
    color: #FFFFFF;

    &:hover, &:active {
      background: #08A747;
    }
  }

  &-red {
    background: #FF445D;
    color: #FFFFFF;

    &:hover, &:active {
      background: #D8152F;
    }
  }

  &-gray {
    background: #D5DFEB;
    color: #3A424E;

    &:hover, &:active {
      background: #BACADC;
    }
  }

  &-search > &-validate > &-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
  }

  &-search > &-validate > &-icon {
    display: flex;
    align-items: center;

    i {
      font-size: 20px;
      margin-right: 8px;
    }
  }

  &-search > &-validate > &-loading > &-spinner {
    > div {
      margin-right: 1.8px !important;
      height: 20px !important;
    }

    .rect5 {
      margin-right: 0 !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/buttons/btnCustom.vue